import classNames from 'classnames';

type Props = {
  description: string;
  className?: string;
  progress?: number | undefined;
};

const MeterProgress = ({ description, className, progress }: Props) => {
  return (
    <div className={classNames('tw-border-b tw-border-gray-300 tw-bg-white tw-px-5 tw-py-5', className)}>
      <h5 className='tw-block tw-text-center tw-text-base tw-font-bold tw-text-free-shipping-meter-text'>
        {description}
      </h5>
      {progress && (
        <div className='tw-mt-[10px] tw-block tw-h-[10px] tw-rounded-md tw-bg-free-shipping-meter-empty'>
          <span
            className='tw-block tw-h-full tw-rounded-md tw-bg-free-shipping-meter-filled'
            style={{ width: `${progress}%` ?? 0 }}></span>
        </div>
      )}
    </div>
  );
};

export default MeterProgress;
